import React, { useState } from "react";
import axiosInstance from '../common/axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Card, CardHeader, CardContent, Typography } from '@mui/material';
const cardStyle = {
  border: "1px solid",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  transition: "box-shadow 0.3s ease",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontWeight: 600,
};

const listStyle = {
  paddingLeft: "20px",
  marginTop: "8px",
  color: "#444",
  fontSize: "14px",
  lineHeight: "1.6",
};


const ProductUpload = ({supplierId}) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  
    const dos = [
    "Use the provided Excel template.",
    "Ensure all required fields (like SKU, Name, Price) are filled.",
    "Keep column headers unchanged.",
    "Check for duplicate values before uploading.",
    "Save file as .xlsx or .csv format."
  ];

  const donts = [
    "Do not change the header names or order.",
    "Avoid leaving mandatory fields empty.",
    "Do not use merged cells or special formatting.",
    "Don’t include extra sheets in the file.",
    "Avoid special characters in Name, Price, etc."
  ];


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleImport = async () => {
    if (!file) {
      setMessage("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axiosInstance.post(`/api/products/import/suppliers/${supplierId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setMessage(response.data);
    } catch (error) {
      setMessage("Error importing file: " + error.response?.data || error.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
    
       {message && (
  <p
    style={{
      marginTop: "12px",
      padding: "10px 16px",
      borderRadius: "6px",
      backgroundColor: message.includes("success") ? "#E6F4EA" : "#FDECEA",
      color: message.includes("success") ? "#2E7D32" : "#C62828",
      border: `1px solid ${message.includes("success") ? "#A5D6A7" : "#EF9A9A"}`,
      fontWeight: "500",
      fontSize: "14px",
    }}
  >
    {message}
  </p>
)}


    
      <h2>Import Products from Excel or CSV </h2>
      <input type="file" accept=".xlsx, .xls" onChange={handleFileChange}

style={{
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease"
  }}
  />
      <br />
      <button onClick={handleImport} style={{
    marginTop: "10px",
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    transition: "background-color 0.3s ease"
  }}

>
        Import Products
      </button>
   
  <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "24px",
        padding: "16px",
      }}
    >
      {/* DOs */}
      <Card style={{ ...cardStyle, borderColor: "#4CAF50" }}>
        <CardHeader
          title={
            <Typography variant="h6" component="div" style={{ ...headerStyle, color: "#4CAF50" }}>
              <CheckCircleIcon color="success" />
              Do’s
            </Typography>
          }
        />
        <CardContent style={{ backgroundColor: "#F1FDF3", borderRadius: "0 0 8px 8px" }}>
          <ul style={listStyle}>
            {dos.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </CardContent>
      </Card>

      {/* DON’Ts */}
      <Card style={{ ...cardStyle, borderColor: "#F44336" }}>
        <CardHeader
          title={
            <Typography variant="h6" component="div" style={{ ...headerStyle, color: "#F44336" }}>
              <CancelIcon color="error" />
              Don’ts
            </Typography>
          }
        />
        <CardContent style={{ backgroundColor: "#FFF1F1", borderRadius: "0 0 8px 8px" }}>
          <ul style={listStyle}>
            {donts.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </div>
    </div>
       
  );
};

export default ProductUpload;
